<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div v-if="project.id">
      <div class="col-sm-8 pl-0">
        <div class="panel">
          <el-page-header @back="$router.go(-1)" content="项目详情">
          </el-page-header>
          <div class="mar-btm">
            <span class="text-main text-semibold">井号：</span
            >{{ project.pit_number }}
            <el-tag size="mini" type="primary">{{
              ProjectDrillStatusMap[project.status]
            }}</el-tag>
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">井队：</span
            >{{ project.pit_team }}
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">区域：</span
            >{{ project.region_info.name }}
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">服务内容：</span
            >{{ project.service }}
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">井深：</span
            >{{ project.pit_depth }}
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">服务开始时间：</span
            >{{
              project.start_time
                ? $time(project.start_time).format('YYYY-MM-DD')
                : ''
            }}
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">位置：</span
            >{{ project.position }}
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">GPS：</span
            >{{ project.gps || '-' }}
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">服务人员：</span>
            <template v-for="(user, index) in project.users">
              {{ index > 0 ? '、' + user.user.name : user.user.name }}
            </template>
          </div>
          <div class="mar-btm">
            <span class="text-main text-semibold">日报数量：</span>
            <router-link
              :to="`/report/reports?project_id=${project.id}`"
              class="text-primary"
              >{{ project.reports.length }}</router-link
            >
          </div>
          <div class="row">
            <h5 class="m-t-20 m-b-10" id="drill-trip">钻头趟数</h5>
            <DrillTripTable :list="project.drill_trips"></DrillTripTable>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="panel">
          <div class="panel-heading">
            <h3 class="panel-title">附件信息</h3>
          </div>
          <ul>
            <li v-for="file in project.attachments" :key="file.id">
              <a :href="file.path" target="_blank">{{ file.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectDetail } from '../../../service/getData'
import DrillTripTable from './_drill_table.vue'
import { ProjectDrillStatusMap } from '@/config/global'

export default {
  components: {
    DrillTripTable,
  },
  data() {
    return {
      project: {},
      ProjectDrillStatusMap,
    }
  },
  created() {
    this.getData(this.$route.params.id)
  },
  methods: {
    async getData(id) {
      let res = await projectDetail(id)
      this.project = res.data
    },
  },
}
</script>